import { make_listicle } from "./listicle_template";

let review = make_listicle("trending_coins",14);

export default review;